// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "title-qH39G";
var _4 = "text-m4keO";
var _5 = "button-ZNM5x";
export { _1 as "__esModule", _2 as "mobile", _3 as "title", _4 as "text", _5 as "button" }
export default { "__esModule": _1, "mobile": _2, "title": _3, "text": _4, "button": _5 }
